export function addCurrent(user) {
    return {
        type: 'ADD_CURRENT_USER',
        user,
    }
}
